/* import __COLOCATED_TEMPLATE__ from './form-template-form-preview.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./form-template-form-preview.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());